﻿import { createContext } from 'react';

import { StudentGroupWithDetails } from 'apis/StudentGroupApi';
import type { ReportPermissions } from 'pages/reports/types';
import { Option, ReportFilter } from 'apis/ReportApi';

interface ReportsDefaultContext {
    classroomCache: Map<string, StudentGroupWithDetails[]>;
    currentUserId: number;
    filterOptionsCache: Map<string, Option[]>;
    filters: ReportFilter[] | undefined;
    permissions: ReportPermissions;
    setFilters: (filters: ReportFilter[] | undefined) => void;
}
export const ReportsDefaultContext = createContext<ReportsDefaultContext>({
    classroomCache: new Map(),
    currentUserId: 0,
    filterOptionsCache: new Map(),
    filters: [],
    permissions: { IsPostFiltering: false, IsStudent: false, PickerPermission: false, ReportFeatureFlag: false },
    setFilters: () => null
});
